module.exports = __webpack_public_path__ + "static/UAmobSlide2-8d73a379607bd8f4847dcde8a5aeedef.jpg";